t = require('views/internal/teacup-with-helpers')('calendar_week')

module.exports = ->
  t.div '.week-horizontal-canvas'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/calendar_week.coffee